import { Directive } from '@angular/core';

/**
 * Spotlight CTA block (component tier). Scene-agnostic by construction.
 *
 * Paints var(--groove-color-bg-surface) under a radial glow from
 * var(--groove-color-decor) at low alpha, radiating from the top centre — the
 * "stage spotlight" motif. Text is
 * centred; the consumer composes heading / copy / actions inside with
 * `[grooveAction]`, `[groovePullquote]`, or plain elements.
 *
 * **Scene-agnostic / composition contract**: the component resolves all colours
 * from the ambient scene. The "dark reprise" pattern — where the CTA
 * appears on a warm-dark stage surface even when the surrounding page is paper —
 * is achieved by the consuming page, not by this component:
 *
 * ```html
 * <!-- Stage reprise on a paper page -->
 * <div data-scene="stage">
 *   <section grooveSpotlight>
 *     <!-- heading / copy / actions -->
 *   </section>
 * </div>
 * ```
 *
 * Without that wrapper the component renders on the ambient (paper) surface
 * with the gold decor glow, which is also a valid use case.
 *
 * No tone / variant axis (YAGNI): both visual forms are structurally identical
 * — scene controls the palette, not a component input. If a second distinct
 * visual form emerges, add a `variant` input then; don't preempt it.
 */
@Directive({
  selector: '[grooveSpotlight]',
  standalone: true,
  host: {
    class: 'groove-spotlight',
  },
})
export class GrooveSpotlightDirective {}
